import { Subscriber } from 'rxjs';

export class SubHeaderDTO {
  taskDescription: string;
  modalDescription: string;
  showProjectInModal = false;
  taskIcon: string;
  project: any;
  division: any;
  visible: any;
  infoVisible: boolean;
  showDocumentsVisible: boolean;
  showCalendarVisible: boolean;
  actions: Array<ActionInterface>;
  windowactions: Map<string, Array<ActionInterface>>;

  static patchDTO(dto: SubHeaderDTO) {
    if (!dto.actions) {
      dto.actions = [];
    }
    if (!dto.windowactions) {
      dto.windowactions = new Map();
    }
  }

  constructor() {
    SubHeaderDTO.patchDTO(this);
  }
}

export interface ActionInterface {
  name: string;
  classes: string;
  icon: string;
  type: string;
  visible: boolean | Function;
  enable: boolean | Function;
  disableTooltip: string;
}

export class ActionGroupElementDTO implements ActionInterface {
  name: string;
  classes: string;
  icon: string;
  visible: boolean | Function;
  enable: boolean | Function;
  disableTooltip: string;
  type: 'group';
  // propiedades de grupo
  id: string;
  actions: Array<ActionElementDTO>;
}

export class ActionElementDTO implements ActionInterface {
  name: string;
  classes: string;
  icon: string;
  type: string;
  visible: boolean | Function;
  action: Subscriber<boolean>;
  enable: boolean | Function;
  disableTooltip: string;
}
